// src/components/forms/BaseForm.jsx
import React from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';

const BaseForm = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title, 
  children, 
  loading = false, 
  submitText = "Submit",
  size = "md"
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size={size}>
      <form onSubmit={onSubmit} className="space-y-4">
        {children}
        
        {/* Form Actions */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={loading}
            disabled={loading}
          >
            {loading ? `${submitText}...` : submitText}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default BaseForm;